import { render, staticRenderFns } from "./Step-1.vue?vue&type=template&id=3af28f46&scoped=true&"
import script from "./Step-1.vue?vue&type=script&lang=js&"
export * from "./Step-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af28f46",
  null
  
)

export default component.exports